var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"job-board-empty"},[_c('div',{staticClass:"job-board-empty-card"},[_c('div',[_vm._v("No Results Found")]),_c('Btn',{attrs:{"route":"","to":"/"}},[_vm._v("Back to All Results")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }